/**
 * Determine readable text color (black or white) for a given background hex.
 * Uses YIQ luminance approximation.
 */
export function contrastText(hex: string): string {
  if (!/^#[0-9A-Fa-f]{6}$/.test(hex)) {
    throw new Error(`contrastText: expected 6-digit hex, got "${hex}"`);
  }
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return r * 0.299 + g * 0.587 + b * 0.114 > 150 ? "#000" : "#fff";
}

/**
 * Lighten a 6-digit hex color toward white by `amount` (0–1).
 * 0 = original color, 1 = pure white. Used for pastel-fallback thumbnails.
 */
export function lightenHex(hex: string, amount: number): string {
  if (!/^#[0-9A-Fa-f]{6}$/.test(hex)) {
    return hex;
  }
  const clamped = Math.min(1, Math.max(0, amount));
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const mix = (c: number) => Math.round(c + (255 - c) * clamped);
  const toHex = (c: number) => c.toString(16).padStart(2, "0");
  return `#${toHex(mix(r))}${toHex(mix(g))}${toHex(mix(b))}`;
}
